export function useDebouncedCallback<T extends (...args: unknown[]) => unknown>(
  callback: T,
  delay: number,
): [(...args: Parameters<T>) => void, () => void] {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const cancelDebounce = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }, [])

  const debouncedCallback = useCallback(
    (...args: Parameters<T>) => {
      cancelDebounce()
      timeoutRef.current = setTimeout(() => callback(...args), delay)
    },
    [callback, delay, cancelDebounce],
  )

  useEffect(() => {
    return cancelDebounce
  }, [cancelDebounce])

  return [debouncedCallback, cancelDebounce]
}
